<script setup>
    import '~/assets/css/catalog-community.css';
    import '~/assets/css/compact-section-header.css';
	const route = useRoute();
    const props = defineProps([
		'category',
        'title',
    ]);
    
	const {query: catalogQuery, data, fetching} = await useCatalogQuery(computed(() => props.category));

	const updateRoute = (query) => {
		navigateTo({ path: route.path, query, replace: true });
	}

	const { value: isFilterOpen, toggle: toggleFilter } = useToggle(false);
	const searchText=ref(String(route.query.search||''));
    const {data:navigation}=await useFetch('/api/catalog/navigation',{query:computed(()=>({root:route.params.category,culture:route.params.subcategory||undefined}))});
    watch(()=>route.query.search,value=>searchText.value=String(value||''));
    const order=computed({get:()=>route.query.sort==='created_at'?'created_at':'',set:value=>updateRoute({...route.query,sort:value||undefined,page:undefined})});
    let searchTimer;
    watch(searchText,value=>{clearTimeout(searchTimer);if(value!==String(route.query.search||''))searchTimer=setTimeout(searchPlants,700);});
    onBeforeUnmount(()=>clearTimeout(searchTimer));
    function searchPlants(){clearTimeout(searchTimer);updateRoute({...route.query,search:searchText.value.trim()||undefined,page:undefined});}
    const searchBrand = ref('');
	const filteredBrands = computed(() => {
		if (!searchBrand.value) return data.value?.uogorod_brands||[];
		return (data.value?.uogorod_brands || []).filter(({ title }) => title.toLowerCase().includes(searchBrand.value.toLowerCase()))
	});

	// TODO отфильтровать только используемые значение из aggregate функции а не только с 1 страницы
	// Тут вроде фильтрация только используемых параметров, так-же должна быть фильтрация параметров в зависимости от категории
	const usedParams = data.value?.uogorod_seed_params.reduce((acc, { name, values }) => {
		acc[name] = [...new Set([...values, ...(acc[name] || [])])];
		return acc;
	}, {});

	const filterData = computed(() => {
		return [
			{
				label: 'Производители',
				name: 'brands',
				class: 'overflow-auto max-h-72',
				type: 'checkbox',
				values: (data.value?.uogorod_brands||[]).reduce((acc, item) => {
					acc[item.id] = item.title;
					return acc;
				}, {})
			},
			{
				label: 'Рейтинг',
				name: 'rate',
				type: 'checkbox',
				values: [5,4,3,2,1],
				slot: 'rate',
			},
			...(data.value?.uogorod_seed_specs||[]),
		];
	});

	const activeFiltersCount = computed(() => Object.keys(catalogQuery.value.filters).length);
</script>

<template>
 <section class="uo-community uo-catalog uo-catalog-category">
 <section class="uc-compact-head uc-category-head"><header class="uc-heading"><div><h1>{{title}}</h1><p>Сорта, фотографии и опыт садоводов.</p></div><span v-if="navigation?.plant_count!==undefined&&navigation?.plant_count!==null" class="uc-total">{{Number(navigation.plant_count).toLocaleString('ru-RU')}} {{normalizeCountForm(Number(navigation.plant_count),['растение','растения','растений'])}}</span></header>
 <form class="uc-search" role="search" @submit.prevent="searchPlants"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="10.8" cy="10.8" r="6.8"/><path d="m16 16 4.5 4.5"/></svg><input v-model="searchText" type="search" placeholder="Найти растение" aria-label="Найти растение в категории"><button type="submit" class="uo-btn uo-btn-primary">Найти</button></form>
 <CatalogSectionMenu v-if="navigation?.cultures?.length" :cultures="navigation.cultures" :root-slug="String(route.params.category)" :selected-slug="String(route.params.subcategory||'')" />
 </section>
 <div class="uo-choice-links"><NuxtLink class="uo-choice-compare" to="/selections">Подборки растений →</NuxtLink><NuxtLink class="uo-choice-compare" to="/questions">Вопросы и ответы →</NuxtLink></div>
 <CatalogQuickFilters :specs="data?.uogorod_seed_specs||[]" :filters="catalogQuery.filters" :brands="data?.uogorod_brands||[]" />
 <CatalogCompareSelection />
 <section v-if="$slots.description" class="uc-description" :aria-label="route.params.subcategory?'О культуре':'О категории'"><h2>О {{route.params.subcategory?'культуре':'категории'}}</h2><slot name="description" /></section>
 <div class="uc-category-toolbar"><label>Сортировка<select v-model="order" aria-label="Сортировка растений"><option value="">По популярности</option><option value="created_at">Новые</option></select></label><button type="button" class="uo-btn uo-btn-secondary" :aria-expanded="isFilterOpen" @click="isFilterOpen=true">Фильтры<span v-if="activeFiltersCount" class="uc-tab-count">{{activeFiltersCount}}</span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></button></div>
	<div class="uo-catalog-category-layout" v-loading="fetching">
	
		<div class="uo-card uo-category-content flex-1 min-w-0 p-4">
			<CatalogSearchResults v-if="catalogQuery.search" :category-slug="route.params.subcategory || route.params.category" :options="catalogQuery" />
			<slot v-else />
		</div>
		<CatalogDiscovery class="uo-catalog-desktop-discovery" :category="String(route.params.subcategory || route.params.category || '')" />
        <CatalogFilterPanel v-if="isFilterOpen" :filter-data="filterData" @close="isFilterOpen=false" />
	</div>
 </section>
</template>
